import { Children, isValidElement, useState, type FC, type ReactNode } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	children: ReactNode;
}

const TagRow: FC<Props> = ({ children }: Props) => {
	const [offsets, setOffsets] = useState<number[]>([]);

	const measure = (index: number, x: number) =>
		setOffsets((current) => {
			if (current[index] === x) {
				return current;
			}

			const next = [...current];
			next[index] = x;

			return next;
		});

	return (
		<ScrollView
			contentContainerStyle={styles.content}
			decelerationRate="fast"
			horizontal={true}
			showsHorizontalScrollIndicator={false}
			snapToAlignment="start"
			snapToOffsets={offsets}
			style={styles.row}
		>
			{Children.map(children, (child, index) =>
				isValidElement(child) ? (
					<View onLayout={({ nativeEvent }) => measure(index, nativeEvent.layout.x - Dimens.padding18)}>{child}</View>
				) : (
					child
				),
			)}
		</ScrollView>
	);
};

const styles = StyleSheet.create({
	row: {
		marginHorizontal: Dimens.paddingMinus18,
	},
	content: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: Dimens.gap6,
		paddingHorizontal: Dimens.padding18,
	},
});

export default TagRow;
